// extracted by mini-css-extract-plugin
module.exports = {"header":"SimilarVehiclesHeader_header__8SsPX","title":"SimilarVehiclesHeader_title__CaFL4","seeAll":"SimilarVehiclesHeader_seeAll__0dRY2"};